import { MoreHorizontal } from 'react-feather';
import React from 'react';

interface Props {
  header: string;
}

const VerticalNavMenuSectionHeader: React.FC<Props> = ({ header }) => {
  return (
    <li className="navigation-header">
      <span>{header}</span>
      <MoreHorizontal className="feather-more-horizontal" />
    </li>
  );
};

export default VerticalNavMenuSectionHeader;
